import React, {
  Component,
  Fragment,
  useContext,
  useState,
  useEffect,
  useRef,
} from "react";

import { Link } from "react-router-dom";
import PAContentBlock from "../PAContentBlock";
import PAInputPrices from "../PAInputPrices";

import PAwebhooks from "../PAwebhooks";
import DatePickerExample from "../DatePicker";
import SelectExample from "../SelectExample";
import SwitchExample from "../SwitchExample";
import PAInputUpgrades from "../PAInputUpgrades";
import PACollapse from "../PACollapse";
import PACollapsePrices from "../PACollapsePrices";
import PAgameKeysDistr from "./PAgameKeysDistr";
import CardNew from "../PAcardNew";
import DistributionBlocker from "./DistributionBlocker";

import { PAgcGKprices } from "./PAgcGKprices";
import { PAskuName } from "../PAskuName";
import { PAgcGKbuypre } from "./PAgcGKbuypre";
import { PAgcGKplatforms } from "./PAgcGKplatforms";
import { PAgcGKassets } from "./PAgcGKassets";
import PAh2 from "../PAh2";

import {
  PAgkRefundPeriods,
  PAgkRefundOption,
  SelectSquare,
  PAgkRefundLine,
  CssTableFlag,
  CssTableCountry,
} from "../ffr/PAgkRefund";

// import PAbreadcrumbs from "./PAbreadcrumbs";

import { withRouter } from "react-router-dom";

import merge from "deepmerge";

// import { ProductConsumer } from "./context";
import { ContextConsumer } from "../PA";

import { IntlProvider } from "react-intl";

import { blankKey, platforms } from "../BlankKey";

// import {FilePicker} from

import {
  InputCopy,
  FormGroup,
  Dropdown,
  FormFooter,
  Select,
  Tooltip,
  Head,
  StatusDot,
  ContentBlock,
  Breadcrumbs,
  Checkbox,
  Subheader,
  Pill,
  Collapse,
  Button,
  Card,
  Input,
  RadioGroup,
  Icon,
  Popover,
  ButtonAction,
  Tag,
  Notification,
} from "xsolla-uikit";

import { setTimeout } from "core-js";
import dropdown from "xsolla-uikit/lib/dropdown";
import { WidgetWizard } from './PAgcWidgetWizard';

const allCurrencies = [
  { label: "USD", id: "USD", value: "USD" },
  { label: "EUR", id: "EUR", value: "EUR" },
  { label: "RUB", id: "RUB", value: "RUB" },
];

let keyData = {};
let data = {};

export function PAgameKeys({ history }) {
  return (
    <ContentBlock>
      <Head
        appearance="separated"
        indentation="xlg"
        extra={
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Dropdown
              autosize={true}
              align="right"
              // separated={true}
              options={[
                {
                  label: "Edit settings",
                  // description: 'The button will start ',
                  // customIcon: <StatusDot status="enabled" />,
                  customIcon: <Icon name="edit" />,
                  iconAlign: "right",
                },
                {
                  label: "Duplicate button",
                  // description: 'The button will start ',
                  // customIcon: <StatusDot status="enabled" />,
                  customIcon: <Icon name="copy" />,
                  iconAlign: "right",
                },
                {
                  label: "Delete button",
                  // description: 'The button will start ',
                  // customIcon: <StatusDot status="enabled" />,
                  customIcon: <Icon name="delete" />,
                  iconAlign: "right",
                },
              ]}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  alignItems: "center",
                  flexGrow: 1,
                  height: "100%",
                  marginLeft: 16,
                }}
              >
                <Icon name="more" size={28} />
              </div>
            </Dropdown>
          </div>
        }
      >
        <Breadcrumbs
          items={[
            {
              label: <PAh2 title="Buttons" indentation="xs" />,
              to: "/game_store/goods",
            },
            {
              label: (
                <PAh2
                  indentation="xs"
                  title={
                    <div style={{ display: "flex" }}>
                      {blankKey.keyData.general.name.value}

                      <span style={{ margin: "-2px 0 0 16px" }}>
                        {blankKey.storeGK !== "not ready" && (
                          <Pill appearance="active">Ready</Pill>
                        )}
                        {blankKey.storeGK === "not ready" && (
                          <Pill appearance="info">Draft</Pill>
                        )}
                      </span>
                    </div>
                  }
                />
              ),
              to: "/game_store/goods",
            },
          ]}
        />
      </Head>

      <FormGroup>
        <PAContentBlock title="General Settings" border={true}>
          <PAskuName data={blankKey} />

          <PAgcGKbuypre />

        </PAContentBlock>

        <PAContentBlock title="Platforms and DRMs" border={true}>
          <FormGroup label="Select platforms" indentation="lg">
              <PAgcGKplatforms data={blankKey} />
          </FormGroup>
        </PAContentBlock>

        <PAContentBlock
          title="Upgrades"
          border={true}
          className="ui-navigation--bordered"
        >
          <PAgameKeysUpgrades />
        </PAContentBlock>

        <PAContentBlock title="Manage Keys and Distributives" border={false}>
          <PAgcGKassets data={blankKey} />

          <DistributionBlocker
            enabled={true}
            webhooksNeeded={true}
            webhooksEnabled={false}
            agreement={false}
          />
        </PAContentBlock>
      </FormGroup>


    </ContentBlock>
  );
}

export const KeyContext = React.createContext();

export class PAgameKeys1OLD extends Component {
  constructor(props) {
    super(props);

    this.newAsset = props.newAsset || true;

    this.handleKeyId = this.props.handleKeyId;

    this.context = null;

    this.generateSku = (newName = "new") => {
      let timestamp = new Date().getTime().toString();
      timestamp = timestamp.substring(timestamp.length - 4, timestamp.length);
      let nameSku = newName.replace(/\s+/g, "_").toLowerCase();
      nameSku = nameSku.substring(0, 8);

      return `${nameSku}_${timestamp}`;
    };

    this.getData = (sku = this.sku) => {
      let newKey = this.state.context.globalState.store.gameKeys.keys[sku] || {
        ...blankKey,
      };

      if (!this.state.context.globalState.store.gameKeys.keys[sku]) {
        let newName = "new game keys package";

        if (!sku) {
          sku = this.generateSku(newName);
        }
        newKey.keyData.general.name.value = newName;
        newKey.keyData.general.sku.value = sku;
        newKey.sku = sku;
      }

      return newKey;
    };

    this.sku = this.props.sku || this.generateSku();

    this.state = {
      unsaved: false,
      editMode: this.props.editMode || false, //TODO: доделатьрежим редактирования
      data: null,

      wizard: this.props.wizard || false,
      currentState: {
        search: false,
        pricesModal: false,
        webhooksModal: false,
      },

      webhooks: {
        value: false,
        isFormModalOpen: false,
      },
    };
  }

  handeCurrDel = (k, e) => {
    // if (!k) return;
    var newCurrs = [...this.state.data.keyData.curs]; // make a separate copy of the array
    if (k !== -1) {
      newCurrs.splice(k, 1);
      this.setState({ curs: newCurrs });
    }
    this.handleParentCurs(newCurrs);
  };

  handeCurrAdd = (e) => {
    let newCurr = {
      curr: this.state.data.keyData.curs[0].curr,
      platform: this.state.data.keyData.curs[0].platform,
      price: this.state.data.keyData.curs[0].price,
      currLocked: false,
      add: false,
    };
    this.setState(
      {
        curs: [...this.state.data.keyData.curs, newCurr],
      },
      () => {
        this.handleParentCurs(this.state.data.keyData.curs);
      }
    );
  };

  handleCurrValue = (curIndex, what, newValue) => {
    // debugger;
    let newCurs = [...this.state.data.keyData.curs];
    newCurs[curIndex][what] = newValue;
    this.setState(
      {
        curs: [...newCurs],
      },
      () => {
        this.handleParentCurs(this.state.data.keyData.curs);
      }
    );
  };

  handleParentCurs = (newAllCurrs) => {
    this.setState(
      {
        data: {
          ...this.state.data,
          keyData: {
            ...this.state.data.keyData,
            curs: [...newAllCurrs],
          },
        },
      },
      () => {
        this.updateStatus();
      }
    );
  };

  closeModal = (modalKey) => {
    this.setState({
      webhooks: {
        ...this.state.webhooks,
        [modalKey]: false,
      },
    });
  };

  checkOS = (onePlatformOn) => {
    let result = onePlatformOn["os"].length ? false : true;

    onePlatformOn["os"].forEach((oneOs) => {
      if (onePlatformOn["distr"] === "keys" && oneOs["value"]) {
        result = true;
      }
      if (onePlatformOn["distr"] === "drmfree") {
        result = oneOs["files"][0]["value"] ? true : result;
      }
    });
    return result;
  };

  setOS = (onePlatformOs, osID, val = "invert") => {
    return onePlatformOs.map((oneOs) => {
      let newVal = oneOs["value"];
      newVal = osID === oneOs["id"] && val !== "invert" ? val : newVal;
      newVal = osID === oneOs["id"] && val === "invert" ? !newVal : newVal;
      newVal = newVal;
      return {
        id: oneOs["id"],
        name: oneOs["name"],
        value: newVal,
      };
    });
  };

  handlePlatform = (index, what, value = "invert") => {
    let platf = [...this.state.data.keyData.platforms]; // make a separate copy of the array
    let onePlatform = platf[index];
    onePlatform[what] = value === "invert" ? !onePlatform[what] : value;
    if (!onePlatform["added"]) {
      onePlatform["uploaded"] = false;
      onePlatform["enabled"] = false;
    }
    this.updateStatus(true, platf);
  };

  /** value = invert / file */
  handleOScheck = (platfIndex, platfId, value = "invert", osId = null) => {
    let platf = [...this.state.data.keyData.platforms]; // make a separate copy of the array
    platf[platfIndex]["os"] = platf[platfIndex]["os"].map((oneOs) => {
      let newVal = oneOs["value"];
      let newFiles = oneOs["files"];
      newVal =
        platfId === oneOs["id"] && typeof value === "boolean" ? value : newVal;
      newVal = platfId === oneOs["id"] && value === "invert" ? !newVal : newVal;
      if (osId === oneOs["id"] && value === "file") {
        newFiles[0]["value"] = !newFiles[0]["value"];
      }
      oneOs["value"] = newVal;
      oneOs["files"] = newFiles;
      return {
        id: oneOs["id"],
        name: oneOs["name"],
        value: oneOs["value"],
        files: oneOs["files"],
      };
    });
    this.updateStatus(true, platf);
  };

  handlePlatformAdd = (newPlatf) => {
    let platf = [...this.state.data.keyData.platforms];
    newPlatf.added = true;
    platf.push(newPlatf);
    this.updateStatus(false, platf);
  };

  updateStatus = (
    saveToGlobal = true, //save to global by default
    platf = [...this.state.data.keyData.platforms],
    curs = [...this.state.data.keyData.curs]
  ) => {
    let added = false;
    let enabled = false;
    let uploaded = false;
    for (let index = 0; index < platf.length; index++) {
      const onePlatform = platf[index];
      if (onePlatform["added"]) {
        added = true;
      }
      if (
        this.state.data.keyData.delivery.value === "xsolla" &&
        onePlatform["added"] &&
        // onePlatform["uploaded"] &&
        this.checkOS(onePlatform)
      ) {
        enabled = true;
        // uploaded = 1;
        // setTimeout(() => {
        //   uploaded = true;
        // }, 5000);
        // this.setState(
        //   {
        //     uploading: true
        //   },
        //   () => {
        //     setTimeout(() => {
        //       this.setState({
        //         uploading: false
        //       });
        //     }, 5000);
        //   }
        // )
      }

      if (
        this.state.data.keyData.delivery.value === "self" &&
        onePlatform["added"] &&
        this.checkOS(onePlatform) &&
        this.state.context.globalState.globalWebhooks.value
      ) {
        enabled = true;
      } else {
        enabled = enabled;
      }
    }

    enabled =
      this.state.data.keyData.buyPre.value === "pre" && added ? true : enabled;

    console.log("enabled = ", enabled);

    let storeGK = enabled === false ? "not ready" : "ready";
    let newData = {
      sku: this.state.data.keyData.general.sku.value,
      storeGK: storeGK,
      keyData: {
        ...this.state.data.keyData,
        // platformsAdded: (platf[i].added) ? true : false,
        curs: curs,
        platformsAdded: added,
        platformsEnabled: enabled,
        platforms: [...platf],
      },
    };

    this.setState(
      {
        data: { ...newData },
        unsaved: true,
      },
      () => {
        // debugger;
        if (saveToGlobal || enabled) {
          this.saveToGlobal(newData);
          if (saveToGlobal === "save and close") {
            this.setState({ editMode: "false" });
          }
        }
      }
    );
  };

  saveToGlobal = (newData = this.state.data) => {
    // if (storeGK === 'ready') {
    let newStoreState = { ...this.state.context.globalState.store };

    newStoreState.gameKeys.keys[
      this.state.data.keyData.general.sku.value
    ] = newData;

    this.state.context.handleCurrentState("store", newStoreState);

    this.setState({
      unsaved: false,
    });
    // }
  };

  handleDeliveryType = (val = "xsolla") => {
    let newData = {
      keyData: {
        delivery: {
          value: val,
        },
      },
    };
    this.setState({
      data: merge(this.state.data, newData),
    });

    let platf = [...this.state.data.keyData.platforms];
    for (let index = 0; index < platf.length; index++) {
      const onePlatform = platf[index];
      onePlatform["enabled"] = false;
      onePlatform["added"] = false;
    }

    let newDataDelivery = {
      storeGK: "not ready",
      keyData: {
        platformsAdded: false,
        platformsEnabled: false,
        platforms: [...platf],
      },
    };

    this.setState(
      {
        data: merge(this.state.data, newData),
      },
      () => {
        this.updateStatus();
        this.state.context.handleCurrentState("globalWebhooks", {
          ...this.state.context.globalState.globalWebhooks,
          needed: val === "xsolla" ? false : true,
        });
      }
    );
  };

  handleWebhooks = (e) => {
    this.setState(
      {
        webhooks: {
          value: !this.state.webhooks.value,
        },
      },
      () => {
        this.updateStatus();
      }
    );
  };

  renderPlatform = ({ onePlatformOn, onePlatfIndex, selfDelivery = false }) => {
    return (
      <div>
        <FormGroup indentation="sm">
          <CardNew wave={false}>
            <div>
              <FormGroup
                border={
                  selfDelivery && onePlatformOn.distr === "distr" ? false : "xs"
                }
                indentation="xs"
              >
                <div
                  style={{
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      fontWeight: "bolder",
                      height: 32,
                      flexGrow: 1,
                    }}
                  >
                    {onePlatformOn.name}
                  </div>

                  <div
                    style={{
                      position: "relative",
                      display: "flex",
                      alignItems: "center",
                      height: 32,
                      top: 0,
                    }}
                  >
                    {!selfDelivery && onePlatformOn.distr === "keys" && (
                      <Button
                        onClick={(e) => {
                          this.handlePlatform(onePlatfIndex, "uploaded", true);
                        }}
                        type="button"
                        icon={"upload"}
                        // icon={
                        //   this.state.platforms[i].enabled
                        //     ? "close"
                        //     : "upload"
                        // }
                        appearance="flatten"
                      >
                        {onePlatformOn.uploaded
                          ? "Upload more keys"
                          : "Upload keys (CSV, TXT)"}
                      </Button>
                    )}

                    <Dropdown
                      size="sm"
                      options={
                        onePlatformOn.distr === "keys"
                          ? [
                              {
                                onClick: () => {
                                  this.handlePlatform(
                                    onePlatfIndex,
                                    "uploaded",
                                    false
                                  );
                                },
                                disabled: onePlatformOn.uploaded ? false : true,
                                label: "Withdraw keys",
                                description: onePlatformOn.uploaded
                                  ? `56 keys will be sent back to your email, ${
                                      onePlatformOn["name"]
                                    } will stop selling`
                                  : null,
                                icon: "circle-remove-mini",
                              },
                              {
                                onClick: () => {
                                  this.handlePlatform(
                                    onePlatfIndex,
                                    "added",
                                    false
                                  );
                                },
                                label: `Delete ${onePlatformOn["name"]}`,
                                description: `56 keys will be sent to your email, ${
                                  onePlatformOn["name"]
                                } will be removed`,
                                icon: "delete",
                              },
                            ]
                          : [
                              {
                                onClick: () => {
                                  this.handlePlatform(
                                    onePlatfIndex,
                                    "uploaded",
                                    false
                                  );
                                },
                                label: "Withdraw keys",
                                description: `56 keys will be sent back to your email, ${
                                  onePlatformOn["name"]
                                } will stop selling`,
                                icon: "circle-remove-mini",
                              },
                              // {
                              //   onClick: () => {
                              //     this.handlePlatform(onePlatfIndex, "uploaded", false);
                              //   },
                              //   label: 'Delete distributives',
                              //   icon: 'circle-remove'
                              // },
                              {
                                onClick: () => {
                                  this.handlePlatform(
                                    onePlatfIndex,
                                    "added",
                                    false
                                  );
                                },
                                label: `Delete ${onePlatformOn["name"]}`,
                                description: `56 keys will be sent to your email, ${
                                  onePlatformOn["name"]
                                } will be removed`,
                                icon: "delete",
                              },
                            ]
                      }
                    >
                      <Button
                        style={{
                          marginLeft: "16px",
                          color: "#747e8a",
                        }}
                        type="button"
                        size="sm"
                        appearance="flatten"
                      >
                        <div
                          style={{
                            width: 1,
                            height: 24,
                            margin: "0 8px 0 0",
                            backgroundColor: "#ccc",
                          }}
                        />

                        <Icon
                          // onClick={e => {
                          //   this.handlePlatform(onePlatfIndex, "added");
                          // }}
                          style={{
                            color: "#747e8a",
                          }}
                          name="more"
                        />
                      </Button>
                    </Dropdown>
                  </div>
                </div>
              </FormGroup>

              {(onePlatformOn.distr === "keys" ||
                onePlatformOn.distr === "drmfree") && (
                <FormGroup indentation="xs">
                  {!selfDelivery && onePlatformOn.distr === "drmfree" && (
                    <FormGroup
                      // border="xs"
                      indentation="xs"
                    >
                      <FormGroup indentation="sm" />
                      <FormGroup
                        label="DRM-free keys:"
                        // border="xs"
                        indentation="xs"
                      />
                    </FormGroup>
                  )}

                  {!selfDelivery && (
                    <FormGroup indentation="xs">
                      <div
                        style={{
                          fontSize: "13px",
                          display: "flex",
                          justifyContent: "start",
                        }}
                      >
                        <StatusDot
                          status={
                            onePlatformOn.uploaded && fakeLoader()
                              ? "enabled"
                              : "testing"
                          }
                          style={{
                            marginRight: 8,
                          }}
                        />
                        <b>{onePlatformOn.name} keys:</b>&nbsp;
                        {onePlatformOn.uploaded && !fakeLoader() && (
                          <img
                            width="24"
                            height="24"
                            src="https://uikit.xsolla.com/static/57d13acd0e98a391cbb0c4f8416913b4.svg"
                          />
                        )}
                        {onePlatformOn.uploaded &&
                          fakeLoader() &&
                          "56 keys left"}
                        {!onePlatformOn.uploaded && "No keys"}
                        {onePlatformOn.distr === "drmfree" &&
                          !onePlatformOn.uploaded && (
                            <div style={{ padding: "4px 0 0 8px" }}>
                              <Button
                                appearance="flatten"
                                onClick={(e) => {
                                  this.handlePlatform(
                                    onePlatfIndex,
                                    "uploaded"
                                  );
                                }}
                              >
                                {/* <Icon name="upload" /> */}
                                Upload
                              </Button>
                            </div>
                          )}
                      </div>
                    </FormGroup>
                  )}

                  {onePlatformOn.os && onePlatformOn.os.length > 0 && (
                    <FormGroup indentation="xs">
                      <div
                        style={{
                          fontSize: "13px",
                          display: "flex",
                        }}
                      >
                        <StatusDot
                          status={
                            this.checkOS(onePlatformOn) ? "enabled" : "testing"
                          }
                          style={{
                            marginRight: 8,
                          }}
                        />{" "}
                        <div
                          style={{
                            display: "flex",
                            fontSize: "13px",
                          }}
                        >
                          <b>{onePlatformOn["osName"]}:</b>&nbsp;&nbsp;
                          {onePlatformOn.os.length &&
                            onePlatformOn.os.map((oneOS, oneOSindex) => {
                              return (
                                <div
                                  key={`${oneOSindex}_${onePlatformOn.id}`}
                                  className="game_keys_os"
                                  style={{
                                    cursor: "pointer",
                                    marginLeft: "0.2em",
                                    marginRight: "0.4em",
                                  }}
                                  onClick={(e) => {
                                    this.handleOScheck(
                                      onePlatfIndex,
                                      oneOS["id"],
                                      "invert"
                                    );
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    checked={
                                      this.state.data.keyData.platforms[
                                        onePlatfIndex
                                      ]["os"][oneOSindex]["value"]
                                    }
                                    onChange={() => {
                                      void 0;
                                    }}
                                  />
                                  {oneOS.value} {oneOS.name}
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </FormGroup>
                  )}
                </FormGroup>
              )}

              {!selfDelivery && onePlatformOn.distr === "drmfree" && (
                // <FormGroup border="xs" indentation="xs" />
                <div
                // style={{borderBottom: '1px solid #f7faff'}}
                />
              )}

              {!selfDelivery &&
                (onePlatformOn.distr === "distr" ||
                  onePlatformOn.distr === "drmfree") && (
                  <FormGroup indentation="xs">
                    {/* Filepicker */}

                    <div
                    // onClick={e => {
                    //   this.handlePlatform(onePlatfIndex, "uploaded");
                    // }}
                    >
                      {!selfDelivery && onePlatformOn.distr === "drmfree" && (
                        <FormGroup
                          // border="xs"
                          indentation="xs"
                        >
                          <FormGroup indentation="sm" />
                          <FormGroup
                            label="DRM-free archive:"
                            // border="xs"
                            indentation="xs"
                          />
                        </FormGroup>
                      )}

                      <div>
                        <FormGroup indentation="sm">
                          {onePlatformOn.os &&
                            onePlatformOn.os.length > 0 &&
                            onePlatformOn.os.map((onePlatformOs, osIndex) => {
                              return (
                                <UploaderLine
                                  key={osIndex}
                                  type={"drmfree"}
                                  onePlatformOn={onePlatformOn}
                                  platfIndex={onePlatfIndex}
                                  osIndex={osIndex}
                                  handleOScheck={this.handleOScheck.bind(this)}
                                />
                              );
                            })}
                        </FormGroup>

                        {!onePlatformOn.uploaded && (
                          <p style={{ color: "#747e8a", fontSize: "14" }}>
                            Upload the game distributive or{" "}
                            <a href="">Xsolla Launcher</a>
                            <Tooltip
                              distance={4}
                              offset="left"
                              label="Launcher lets you balance the cost and speed of content delivery with a customizable, easy-to-integrate global client app."
                            />
                            <br />
                            The file size must not exceed 20GB
                          </p>
                        )}

                        {onePlatformOn.uploaded === true &&
                          !this.state.uploading && (
                            <p style={{ color: "#747e8a", fontSize: "14" }}>
                              Users will get the download link after the
                              purchase.
                            </p>
                          )}
                      </div>
                    </div>
                  </FormGroup>
                )}

              {this.state.data.keyData.buyPre.value === "pre" &&
                !onePlatformOn.enabled && (
                  <div
                    style={{
                      display: "flex",
                      marginTop: 0,
                    }}
                  >
                    <div
                      style={{
                        fontSize: "13px",
                      }}
                    >
                      {onePlatformOn.distr === "keys" && (
                        <Notification
                          size="sm"
                          title="Please upload the keys before {date}"
                          status="warning"
                          appearance="minimal"
                        />
                      )}

                      {onePlatformOn.distr === "distr" && (
                        <Notification
                          size="sm"
                          title="Please upload the distributive before {date}"
                          status="warning"
                          appearance="minimal"
                        />
                      )}
                    </div>
                  </div>
                )}
            </div>
          </CardNew>
        </FormGroup>
      </div>
    );
  };

  componentDidMount() {
    // debugger;
    if (!this.state.context) {
      !this.data &&
        this.setState({
          context: { ...merge({ ...this.context }, {}) },
        });
    }

    // fetch(`https://api.twitter.com/user/${handle}`)
    //   .then((user) => {
    //     this.setState(() => ({ user }))
    //   })
  }

  handleKeyState = (what, newState, callback = false) => {
    if (what === "0") {
      this.setState(
        {
          ...newState,
        },
        () => {
          callback && callback();
        }
      );
    } else {
      this.setState(
        {
          ...this.state,
          [what]: newState,
        },
        () => {
          callback && callback();
        }
      );
    }
  };

  shouldComponentUpdate() {
    console.log(
      "this.state.context.globalState.globalAgreement.value = ",
      this.state.context
        ? this.state.context.globalState.globalAgreement.value
        : null
    );
    return true;
  }

  componentWillUpdate() {
    if (
      this.state.data &&
      (this.props.match &&
        this.props.match.params.keyId !==
          this.state.data.keyData.general.sku["value"])
    ) {
      // props.history.pushState(this.state.data.keyData.general.sku['value'], this.state.data.keyData.general.name['value'], `/game_keys/${this.state.data.keyData.sku['value']}`);
      if (this.props.match.path !== "/game_keys/newkey") {
        this.props.history.push(this.state.data.keyData.general.sku["value"]);
      }
    }
  }

  componentDidUpdate() {
    this.sku = this.props.match ? this.props.match.params.keyId : this.sku;
    if (!this.state.data && this.state.context) {
      let newData = this.getData(this.sku);
      !this.data &&
        this.setState(
          {
            sku: this.sku,
            data: newData,
          },
          () => {
            this.updateStatus();
          }
        );
    }
  }

  render() {
    return (
      <KeyContext.Provider
        value={{
          keyState: this.state,
          handleKeyState: this.handleKeyState.bind(this),
        }}
        // value={{
        //   state: {...this.state},
        //   handleCurrentState: this.handleCurrentState.bind(this),
        // }}
      >
        <ContextConsumer>
          {(context) => {
            if (context && !this.state.context) {
              this.context = context;
            }
            return (
              <div>
                {this.state.context && this.state.data && (
                  <div className="">
                    <div className={!this.props.wizard ? "xsui-width" : ""}>
                      {false && (
                        <FormGroup indentation="lg">
                          <Breadcrumbs
                            items={[
                              {
                                label: "Game store",
                                to: "/game_store/goods",
                              },
                              {
                                label: (
                                  <React.Fragment>
                                    <div style={{ display: "flex" }}>
                                      {
                                        this.getData(this.sku).keyData.general
                                          .name.value
                                      }

                                      <span style={{ margin: "-4px 0 0 16px" }}>
                                        {this.state.data.storeGK !==
                                          "not ready" && (
                                          <Pill appearance="active">
                                            <StatusDot status="enabled">
                                              Ready
                                            </StatusDot>
                                          </Pill>
                                        )}
                                        {this.state.data.storeGK ===
                                          "not ready" && (
                                          <Pill appearance="warning">
                                            <StatusDot status="testing">
                                              Draft
                                            </StatusDot>
                                          </Pill>
                                        )}
                                      </span>
                                    </div>
                                  </React.Fragment>
                                ),
                                to: "/game_store/goods",
                              },
                            ]}
                          />
                        </FormGroup>
                      )}

                      <ContentBlock>
                        <FormGroup>
                          <PAh2
                            title={
                              <span>
                                {this.state.data.keyData.general.name["value"]}
                                <span style={{ margin: "-6px 0 0 16px" }}>
                                  <Pill appearance="warning">
                                    <StatusDot status="testing">
                                      Draft
                                    </StatusDot>
                                  </Pill>
                                </span>
                              </span>
                            }
                            border="lg"
                          />
                        </FormGroup>

                        <div className="xsui-content-block__entry">
                          <div
                            style={{
                              display: "flex",
                              flex: "1 1 0%",
                              flexDirection: "column",
                            }}
                          >
                            {(!this.props.wizard ||
                              this.props.wizard === 2) && (
                              <PAContentBlock
                                wizard={this.props.wizard}
                                title="General Settings"
                                border={true}
                              >
                                <FormGroup border="lg">
                                  <PAskuName data={this.state.data} />
                                </FormGroup>

                                <FormGroup
                                  label="Select platforms"
                                  indentation="lg"
                                >
                                  <PAgcGKplatforms data={this.state.data} />
                                </FormGroup>

                                {/* SAVE CHANGES BUTTON */}
                                {!this.props.wizard &&
                                  this.state.unsaved &&
                                  this.state.editMode && (
                                    <FormGroup>
                                      <div
                                        style={{
                                          display: "grid",
                                          placeItems: "center end",
                                        }}
                                      >
                                        <Button
                                          disabled={
                                            this.state.unsaved ? false : true
                                          }
                                          // disabled={true}
                                          size="sm"
                                          type="submit"
                                          appearance="secondary"
                                          onClick={(e) =>
                                            this.updateStatus("save and close")
                                          }
                                        >
                                          Save Changes
                                        </Button>
                                      </div>
                                    </FormGroup>
                                  )}
                              </PAContentBlock>
                            )}

                            <PAContentBlock
                              title="Selling Options"
                              border={true}
                              className="ui-navigation--bordered"
                              wizard={this.props.wizard}
                            >
                              <PAgcGKbuypre data={this.state.data} />

                              {/* <FormGroup label="" indentation="md">
                                  <SwitchExample
                                    value={true}
                                    label="Can be gifted to a friend via email"
                                  />
                                </FormGroup> */}

                              {!this.props.wizard && (
                                <GKupgradesToggle
                                  on={
                                    this.state.data.keyData.upgrades
                                      ? this.state.data.keyData.upgrades.value
                                      : false
                                  }
                                  handleUpgradesOn={(newVal) => {
                                    this.setState({
                                      data: merge(this.state.data, {
                                        keyData: {
                                          upgrades: { value: newVal },
                                        },
                                      }),
                                    });
                                  }}
                                />
                              )}

                              {/* SAVE CHANGES BUTTON */}
                              {!this.props.wizard &&
                                this.state.unsaved &&
                                this.state.editMode && (
                                  <FormGroup>
                                    <div
                                      style={{
                                        display: "grid",
                                        placeItems: "center end",
                                      }}
                                    >
                                      <Button
                                        disabled={
                                          this.state.unsaved ? false : true
                                        }
                                        // disabled={true}
                                        size="sm"
                                        type="submit"
                                        appearance="secondary"
                                        onClick={(e) =>
                                          this.updateStatus("save and close")
                                        }
                                      >
                                        Save Changes
                                      </Button>
                                    </div>
                                  </FormGroup>
                                )}
                            </PAContentBlock>

                            <PAContentBlock
                              title="Manage Keys and Distributives"
                              border={false}
                              wizard={this.props.wizard}
                            >
                              <PAgcGKassets data={this.state.data} />

                              <FormGroup indentation="lg">
                                <FormGroup>
                                  <SwitchExample
                                    value={false}
                                    label="Show key on the purchase status page"
                                    tooltip="Make the game key visible to the player right after the purchase is completed. Otherwise, the key will be sent in an email"
                                  />
                                </FormGroup>

                                <FormGroup>
                                  <SwitchExample
                                    value={false}
                                    label="Automatic activation of DRM-free keys"
                                    tooltip="The users will receive the keys that are already activated"
                                  />
                                </FormGroup>
                              </FormGroup>

                              {!this.props.wizard && (
                                <DistributionBlocker
                                  enabled={true}
                                  webhooksNeeded={
                                    this.state.context.globalState
                                      .globalWebhooks.needed
                                  }
                                  webhooksEnabled={
                                    this.state.context.globalState
                                      .globalWebhooks.value
                                  }
                                  agreement={
                                    this.state.context.globalState
                                      .globalAgreement.value
                                  }
                                />
                              )}

                              {/* {!this.state.context.globalState.globalAgreement['value'] && (
                                  <FormGroup indentation="lg">
                                    <Notification
                                      status="warning"
                                      icon={true}
                                      style={{ width: "100%" }}
                                    >
                                      To start selling{" "}
                                      <a href="#">sign licensing agreement</a>
                                    </Notification>
                                  </FormGroup>
                                )} */}
                            </PAContentBlock>

                            <div className="xsui-form-footer__entry">
                              <div>
                                <Link
                                  to="/game_keys/"
                                  aria-current="true"
                                  href="#"
                                >
                                  <button
                                    className="xsui-button xsui-button--appearance-outline xsui-button--size-md"
                                    type="button"
                                  >
                                    Exit
                                  </button>
                                </Link>

                                {/* <div
                                    style={{
                                      marginLeft: "1em",
                                      height: 24
                                    }}
                                    className="xsui-messages__succeeded"
                                  >
                                    Saved successfully
                                  </div> */}

                                {/* <Button
                              style={{ marginLeft: "16px", height: "56px" }}
                              type="button"
                              size="sm"
                              appearance="icon"
                            >
                              <Icon name="delete" />
                            </Button> */}
                              </div>

                              <div>
                                <div className="xsui-messages__succeeded">
                                  Saved successfully
                                </div>
                                {/* <Link to="/game_keys/"> */}

                                <ButtonSave callback={this.updateStatus} />

                                {/* </Link> */}
                              </div>
                            </div>

                            <div className="xsui-form-footer xsui-form-footer--down xsui-form-footer--centered xsui-form-footer--sticky">
                              <div className="xsui-form-footer__entry">
                                {this.props.wizard !== 1 && (
                                  <Button
                                    appearance="secondary"
                                    style={{
                                      position: "absolute",
                                      left: 0,
                                      color: "#747e8a",
                                    }}
                                    appearance="flatten"
                                    onClick={(e) => {
                                      this.props.handleWizard(
                                        this.props.wizard - 1
                                      );
                                    }}
                                  >
                                    <Icon name="chevron-reverse" />
                                  </Button>
                                )}

                                {this.props.wizard !== 3 && (
                                  <Button
                                    // className="xsui-button xsui-button--appearance-primary xsui-button--size-md"
                                    type="button"
                                    // appearance="secondary"
                                    onClick={
                                      this.props.wizard === 3 &&
                                      this.state.data.storeGK === "not ready"
                                        ? // (e) => { alert('Not Ready') }
                                          (e) => {
                                            this.props.handleModal();
                                          }
                                        : this.props.wizard === 3 &&
                                          this.state.data.storeGK === "ready"
                                        ? (e) => {
                                            this.updateStatus("save and close");
                                          }
                                        : (e) => {
                                            this.props.handleWizard &&
                                              this.props.handleWizard(
                                                this.props.wizard + 1
                                              );
                                          }
                                    }
                                  >
                                    {this.props.wizard === 1 && "Set up Prices"}
                                    {this.props.wizard === 2 &&
                                      "Set up Delivery"}
                                    {this.props.wizard === 3 && "Finish"}
                                  </Button>
                                )}

                                {this.props.wizard === 3 &&
                                  this.state.data.storeGK !== "ready" && (
                                    <Button disabled={true}>Finish</Button>
                                  )}

                                {this.props.wizard === 3 &&
                                  this.state.data.storeGK === "ready" && (
                                    <Link to="/game_keys/">
                                      <Button
                                        type="button"
                                        // appearance="secondary"
                                        onClick={(e) => {
                                          this.updateStatus("save and close");
                                        }}
                                        disabled={false}
                                      >
                                        Finish
                                      </Button>
                                    </Link>
                                  )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </ContentBlock>
                    </div>
                  </div>
                )}

                {this.state.data && (
                  <div className="xsui-width">
                    <PAgameKeysDistr
                      sku={this.state.data.keyData.general.sku["value"]}
                      // handleCurrentState={
                      //   this.state.context
                      //     ? this.state.context.handleCurrentState
                      //     : null
                      // }
                      platformsEnabled={
                        this.state.data
                          ? this.state.data.keyData.platformsEnabled
                          : null
                      }
                      // globalAgreement={
                      //   this.state.context
                      //     ? this.state.context.globalState.globalAgreement.value
                      //     : false
                      // }
                    />
                  </div>
                )}
              </div>
            );
          }}
        </ContextConsumer>
      </KeyContext.Provider>
    );
  }
}

export default withRouter((props) => <PAgameKeys {...props} />);

const renderPlatformOld = (onePlatformOn, onePlatformIndex) => {
  if (onePlatformOn.distr === "distr") {
    return (
      <FormGroup border="md" indentation="xs">
        <div
          style={{
            display: "flex",
            // flexBasis: "50%",
            // width: "50%",
            flexGrow: 0,
            flexShrink: 1,
          }}
          key={`${onePlatformIndex}_${onePlatformOn.id}`}
          appearance="primary"
          className="xsui-form-group--indentation-sm"
        >
          <Checkbox
            name={onePlatformOn.id}
            label={onePlatformOn.name}
            input={{
              value: this.state.data.keyData.platforms[onePlatformIndex][
                "added"
              ],
              onChange: (e) => {
                this.handlePlatform(onePlatformIndex, "added");
              },
            }}
          />
        </div>
      </FormGroup>
    );
  }
  if (onePlatformOn.distr === "keys") {
    return (
      <div
        style={
          {
            // display: 'flex',
            // flexBasis: "50%",
            // width: "50%",
            // flexGrow: 0,
            // flexShrink: 0,
          }
        }
        key={`${onePlatformIndex}_${onePlatformOn.id}`}
        appearance="primary"
        className="xsui-form-group--indentation-sm"
      >
        <FormGroup indentation="sm">{onePlatformOn.name}</FormGroup>
        <FormGroup border="md">
          <div
            style={{
              display: "flex",
            }}
          >
            {onePlatformOn.os.map((onePlatformOs, ind) => {
              return (
                <div
                  key={`os_${ind}`}
                  style={{
                    display: "flex",
                    marginRight: 16,
                  }}
                >
                  <Checkbox
                    name={onePlatformOs["name"]}
                    label={onePlatformOs["name"]}
                    input={{
                      value: this.state.data.keyData.platforms[
                        onePlatformIndex
                      ]["os"][ind]["value"],
                      // onChange: e => {
                      //   this.handlePlatform(
                      //     index,
                      //     "added"
                      //   );
                      // }
                    }}
                  />
                </div>
              );
            })}
          </div>
        </FormGroup>
      </div>
    );
  }
};

export const timezones = [
  {
    label: "UTC-11:00 Midway",
    value: "-11:00",
  },
  {
    label: "UTC-10:00 Honolulu",
    value: "-10:00",
  },
  {
    label: "UTC-09:30 Marquesas Islands",
    value: "-09:30",
  },
  {
    label: "UTC-09:00 Gambier",
    value: "-09:00",
  },
  {
    label: "UTC-08:00 ",
    value: "-08:00",
  },
  {
    label: "UTC-07:00 Los Angeles",
    value: "-07:00",
  },
  {
    label: "UTC-06:00 Denver",
    value: "-06:00",
  },
  {
    label: "UTC-05:00 Chicago",
    value: "-05:00",
  },
  {
    label: "UTC-04:00 Caracas, New York, Santo Domingo",
    value: "-04:00",
  },
  {
    label: "UTC-03:00 Buenos Aires, Hamilton (Bermuda), Sao Paulo",
    value: "-03:00",
  },
  {
    label: "UTC-02:30 St. John’s (Newfoundland and Labrador)",
    value: "-02:30",
  },
  {
    label: "UTC-02:00 ",
    value: "-02:00",
  },
  {
    label: "UTC-01:00 Cape Verde",
    value: "-01:00",
  },
  {
    label: "UTC+00:00 Bissau, Dakar, Monrovia, Reykjavik, Saint Helena",
    value: "+00:00",
  },
  {
    label: "UTC+01:00 London",
    value: "+01:00",
  },
];

export const years = [
  {
    label: "2019",
    value: "2019",
  },
  {
    label: "2020",
    value: "2020",
  },
  {
    label: "2021",
    value: "2021",
  },
  {
    label: "2022",
    value: "2022",
  },
  {
    label: "2023",
    value: "2023",
  },
];

function fakeLoader(time = 2000) {
  const [keys, setKeys] = useState(false);
  useEffect(() => {
    if (!keys) {
      setTimeout(() => {
        setKeys(!keys);
      }, time);
    }
  });
  return keys;
}

function fakeSaving(time = 2000) {
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    if (!saving) {
      setTimeout(() => {
        setSaving(!saving);
      }, time);
    }
  });
  return saving;
}

const ButtonSave = ({
  callback = () => {
    void 0;
  },
  time = 2000,
}) => {
  const [saving, setSaving] = useState(false);

  return (
    <Button
      // disabled={
      //   this.state.data.storeGK === "not ready"
      //     ? true
      //     : false
      // }
      disabled={!saving ? false : true}
      className="xsui-button xsui-button--appearance-primary xsui-button--size-md"
      type="submit"
      onClick={(e) => {
        setSaving(true);
        setTimeout(() => {
          setSaving(false);
        }, time);
        callback("save and close");
      }}
    >
      {saving ? (
        <span style={{ position: "relative" }}>
          &nbsp;
          <img
            style={{
              position: "absolute",
              left: "50%",
              zIndex: 100,
              marginLeft: "-12px",
              width: "24px",
              height: "24px",
            }}
            src="https://cdn.xsolla.net/publisher-v4/xsolla_preloader_white.svg"
          />
          &nbsp;
        </span>
      ) : (
        "Save"
      )}
    </Button>
  );
};

const UploaderLine = ({
  osIndex,
  onePlatformOn,
  platfIndex,
  onePlatformOs,
  handleOScheck,
}) => {
  return (
    <div
      key={`os_${osIndex}`}
      style={{
        display: "flex",
        marginRight: 16,
      }}
    >
      {onePlatformOn["distr"] === "drmfree" && (
        <FormGroup indentation="xs">
          <div
            style={{ margin: "0px 0 4px 0" }}
            className={"ui-form__keys-uploader__container"}
          >
            {/* <span className={('ui-form__keys-uploader__container__platform-title')}>Distributive:</span> */}

            <div
              style={{ display: "flex" }}
              // className={"ui-form__keys-uploader__container__status"}
            >
              <StatusDot
                status={
                  // onePlatformOn['os'][osIndex]['files'][0]['value'] && fakeLoader() ? "enabled" : "testing"
                  onePlatformOn["os"][osIndex]["files"][0]["value"]
                    ? "enabled"
                    : "testing"
                }
                style={{
                  marginRight: 8,
                }}
              />
              &nbsp;
              {!onePlatformOn["os"][osIndex]["files"][0]["value"] && (
                <span>{onePlatformOn["os"][osIndex]["name"]} Distributive</span>
              )}
              {onePlatformOn["os"][osIndex]["files"][0]["value"] && (
                <span>
                  <span>{onePlatformOn["os"][osIndex]["name"]}: </span>{" "}
                  {onePlatformOn["os"][osIndex]["files"][0]["name"]}
                </span>
              )}
            </div>

            <div className={"ui-form__keys-uploader__container__actions"}>
              {!onePlatformOn["os"][osIndex]["files"][0]["value"] && (
                <Button
                  appearance="flatten"
                  onClick={(e) => {
                    handleOScheck(
                      platfIndex,
                      onePlatformOn["id"],
                      "file",
                      onePlatformOn["os"][osIndex]["id"]
                    );
                  }}
                >
                  <Icon name="upload" />
                  {"  "}Upload
                </Button>
              )}

              {onePlatformOn["os"][osIndex]["files"][0]["value"] && (
                <Dropdown
                  size="sm"
                  options={[
                    {
                      label: "Download distributive",
                      // description: onePlatformOn.uploaded ? `56 keys will be sent back to your email, ${onePlatformOn['name']} will stop selling` : null,
                      icon: "cloud-download",
                    },
                    {
                      onClick: (e) => {
                        handleOScheck(
                          platfIndex,
                          onePlatformOn["id"],
                          "file",
                          onePlatformOn["os"][osIndex]["id"]
                        );
                      },
                      label: `Delete distributive`,
                      description: `${
                        onePlatformOn["os"][osIndex]["files"][0]["name"]
                      } will be deleted from our servers`,
                      icon: "delete",
                    },
                  ]}
                >
                  <Button
                    style={{
                      marginLeft: "16px",
                      height: "56px",
                      color: "#747e8a",
                    }}
                    type="button"
                    size="sm"
                    appearance="flatten"
                  >
                    <div
                      style={{
                        width: 1,
                        height: 24,
                        margin: "0 8px 0 0",
                        backgroundColor: "#ccc",
                      }}
                    />

                    <Icon
                      // onClick={e => {
                      //   this.handlePlatform(onePlatfIndex, "added");
                      // }}
                      style={{
                        color: "#747e8a",
                      }}
                      name="more"
                    />
                  </Button>
                </Dropdown>
              )}
            </div>
          </div>
        </FormGroup>
      )}
    </div>
  );
};

const GKupgradesToggle = ({
  on = false,
  handleUpgradesOn = () => {
    void 0;
  },
}) => {
  return (
    <FormGroup label="" indentation="md">
      <div className="xsui-switch-container  xsui-form-group--indentation-sm">
        <SwitchExample
          label="Can be upgraded"
          tooltip="Increase average revenue per user (ARPU) by letting gamers upgrade to a higher tier package than the one they currently own, while only paying the price difference between the two"
          handleToggle={() => {
            on = !on;
            handleUpgradesOn(on);
          }}
        />
      </div>

      {!!on && (
        <div className="xsui-form-group--primary xsui-form-group--indentation-sm">
          <Notification title="" status="info">
            Your request will be sent to the integration team. We will contact
            you soon to complete the upgrades setup.
          </Notification>

          {/* <FormGroup indentation="sm">
            <PAInputUpgrades
              key={1}
              id={1}
              value="My Game Standard edition"
              price={20}
            />
          </FormGroup>

          <FormGroup indentation="sm">
            <PAInputUpgrades
              key={1}
              id={1}
              value="My Game Ultimate Edition"
              price={0}
            />
          </FormGroup> */}
        </div>
      )}
    </FormGroup>
  );
};

const PlatformSelect = ({
  label = "",
  platforms = [],
  handlePlatform = () => {
    void 0;
  },
  showSelected = true,
}) => {
  return (
    <FormGroup label={label}>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
        }}
      >
        {!!platforms.length &&
          platforms.map((onePlatform, i) => {
            if (showSelected || (!showSelected && !onePlatform.added)) {
              return (
                <div
                  key={`platform_${i}`}
                  style={{
                    marginBottom: "8px",
                    marginRight: "8px",
                    flexGrow: 0,
                  }}
                >
                  <Tag
                    key={`${i}_${onePlatform.name}`}
                    selected={onePlatform.added}
                    value={onePlatform.name}
                    appearance="primary"
                    onClick={(e) => {
                      handlePlatform(onePlatform.id);
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                      }}
                    >
                      <div className="xsui-tag__label">{onePlatform.name}</div>
                    </div>
                  </Tag>
                </div>
              );
            }
          })}
      </div>
    </FormGroup>
  );
};

const GKpriceLines = ({ onePlatform = null }) => {
  return (
    <div>
      {onePlatform["prices"] && (
        <FormGroup label={onePlatform["name"]}>
          <Collapse
            isOpened={false}
            staticElements={1}
            collapsedLabel={(count) => `${count} pricing options`}
            expandedLabel={() => "Hide pricing options"}
          >
            {onePlatform["prices"].map((onePrice) => (
              <FormGroup label="" indentation="md">
                {/* {onePlatform['prices']} */}
                <GKpriceOneLine
                  options={allCurrencies}
                  valueCurr={onePrice["id"]}
                />
              </FormGroup>
            ))}
          </Collapse>
        </FormGroup>
      )}

      {!onePlatform["prices"] &&
        allCurrencies.map((oneCurr) => (
          <FormGroup label="" indentation="md">
            {oneCurr["id"]}
          </FormGroup>
        ))}
    </div>
  );
};

const GKpriceOneLine = ({
  onePlatform = null,
  disabled = false,
  options = { allCurrencies },
  valueCurr = "USD",
  valuePrice = 0,
  valuePlatf = "steam",
}) => {
  return (
    <FormGroup indentation="xs">
      <div style={{ display: "flex" }}>
        <div
          className="xsui-input--dock-right"
          style={{
            flexGrow: 0,
            width: "50%",
            flexBasis: "50%",
          }}
        >
          <Select
            // disabled={this.disabled}
            name=""
            options={options}
            searchable={false}
            autosize={false}
            dock={"right"}
            size={"md"}
            disabled={disabled}
            input={{
              name: "test",
              onChange: (e) => {
                void 0;
              },
              value: valueCurr,
            }}
          />
        </div>

        <Input
          style={{
            flexGrow: 1,
            flexBasis: "50%",
          }}
          dock={"left"}
          input={{
            name: "with-icon",
            value: 0,
            // extraLabel: keyContext.keyState.data.keyData.curs[priceId].currLocked
            // ? "DEFAULT" : null,
            onChange: (e) => {
              // handleValue("price", e.target.value);
            },
          }}
          offset="right"
          extra={
            <Icon
              name="delete"
              hoverable={true}
              // onClick={e => handeCurrDel(priceId, e)}
            />
          }
        />
      </div>
    </FormGroup>
  );
};

const TagIcon = ({ active = false, product = "steam" }) => {
  return (
    <div
      class="xsui-tag xsui-tag--appearance-primary"
      data-value="Epic Games Store"
    >
      <div class="xsui-tag__label">
        <div style="display: flex;">
          <div class="xsui-tag__label">Epic Games Store</div>
        </div>
      </div>
      <div class="xsui-tag__trigger">
        <i
          class="xsui-icon xsui-icon-remove-circle"
          style="font-size: 20px; color: inherit;"
        />
      </div>
    </div>
  );
};

const platformIcons = {
  steam: {
    icon: `<svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M20.528 36.4908C21.3158 36.4908 22.0885 36.1196 22.5551 35.4362C23.3005 34.3492 22.9975 32.8762 21.8794 32.1515L19.9644 30.9084C20.2916 30.823 20.6371 30.7758 20.9946 30.7758C23.1521 30.7758 24.9004 32.4756 24.9004 34.573C24.9004 36.6705 23.1521 38.3703 20.9946 38.3703C18.8948 38.3703 17.1828 36.7589 17.0919 34.741L19.1796 36.0931C19.5917 36.3612 20.0613 36.4908 20.528 36.4908ZM36.4602 12.9209C39.1813 12.9209 41.4084 15.0861 41.4084 17.7344V36.9798C41.4084 39.6282 39.1813 41.7934 36.4602 41.7934H16.6646C13.9405 41.7904 11.7134 39.6282 11.7134 36.9769V31.256L15.2314 33.5361C14.895 35.3184 15.4314 37.2243 16.8494 38.603C19.1372 40.8271 22.849 40.8271 25.1368 38.603C26.5427 37.2361 27.0851 35.3478 26.7639 33.5803L33.9847 27.2909C35.327 27.1023 36.6178 26.5073 37.6511 25.5057C40.1873 23.04 40.1873 19.0395 37.6511 16.5738C35.1149 14.1081 31 14.1081 28.4638 16.5738C27.4306 17.5783 26.8215 18.8333 26.6276 20.1383L20.6916 28.8846C19.7674 28.9317 18.8523 29.188 18.0312 29.6564L11.7134 25.5616V17.7344C11.7134 15.0861 13.9405 12.9209 16.6646 12.9209H36.4602ZM37.6965 21.0397C37.6965 18.5475 35.6179 16.5296 33.0574 16.5296C30.497 16.5296 28.4184 18.5505 28.4184 21.0397C28.4184 23.529 30.497 25.5498 33.0574 25.5498C35.6179 25.5498 37.6965 23.5319 37.6965 21.0397ZM30.2728 21.0397C30.2728 19.5462 31.5182 18.3325 33.0574 18.3325C34.5967 18.3325 35.8421 19.5432 35.8421 21.0397C35.8421 22.5362 34.5967 23.747 33.0574 23.747C31.5182 23.747 30.2728 22.5362 30.2728 21.0397Z" fill="#C5D0DB"/>
    </svg>`,
  },
  gog: {
    icon: `<svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M26.6106 32.2587C26.9929 32.2587 27.3009 32.5714 27.3009 32.9594V32.9644V36.4864C27.3009 36.8722 26.9929 37.1892 26.6106 37.1892L26.6026 37.1849V37.1892H23.1136V37.1849L23.106 37.1892C22.7222 37.1892 22.4142 36.8722 22.4142 36.4864V32.9644V32.9594C22.4142 32.5714 22.7222 32.2587 23.106 32.2587H23.1136H26.6026H26.6106ZM28.499 15.8913C28.8903 15.8913 29.195 16.2098 29.195 16.6021V16.6078V20.1791V20.1837C29.195 20.5767 28.8903 20.896 28.499 20.896H28.4914H24.9484H24.9434C24.5532 20.896 24.2406 20.5767 24.2406 20.1837V20.1791V16.6078V16.6021C24.2406 16.2098 24.5532 15.8913 24.9434 15.8913H24.9484H28.4914H28.499ZM43.1302 25.7187C43.1302 26.7422 42.3088 27.5669 41.3002 27.5669H33.4486V25.1846H40.063H40.0679C40.4589 25.1846 40.7723 24.8646 40.7723 24.4731V24.4681V16.6077V16.6024C40.7723 16.2101 40.4589 15.8913 40.0679 15.8913H40.063H36.5172H36.5104C36.1254 15.8913 35.811 16.2101 35.811 16.6024V16.6077V20.179V20.1836C35.811 20.5766 36.1254 20.8959 36.5104 20.8959H36.5172H39.3505V23.2774H35.2795C34.2671 23.2774 33.4483 22.4515 33.4483 21.4307V15.3566C33.4483 14.3369 34.2671 13.5088 35.2795 13.5088H41.2998C42.3084 13.5088 43.1298 14.337 43.1298 15.3566V25.7186L43.1302 25.7187ZM43.1234 39.5357H40.7967V32.259H39.1702H39.1622C38.7773 32.259 38.4704 32.5717 38.4704 32.9598V32.9647V39.5359H36.144V32.2591H34.5137H34.5084C34.1234 32.2591 33.8158 32.5719 33.8158 32.9599V32.9649V39.5422H31.4898V31.7277C31.4898 30.7272 32.2957 29.912 33.294 29.912H43.1235V39.536L43.1234 39.5357ZM29.7306 23.2776H23.7082C22.6977 23.2776 21.8793 22.4518 21.8793 21.431V15.3569C21.8793 14.3372 22.6977 13.5091 23.7082 13.5091H29.7306C30.7392 13.5091 31.5599 14.3372 31.5599 15.3569V21.431C31.5599 22.4518 30.7392 23.2776 29.7306 23.2776ZM29.6268 37.7162C29.6268 38.7209 28.819 39.5357 27.8237 39.5357H21.8922C20.8931 39.5357 20.0876 38.7209 20.0876 37.7162V31.7274C20.0876 30.7268 20.8931 29.9117 21.8922 29.9117H27.8237C28.819 29.9117 29.6268 30.7268 29.6268 31.7274V37.7162ZM19.9911 25.7187C19.9911 26.7422 19.1704 27.5669 18.1595 27.5669H10.3094V25.1846H16.9213H16.9282C17.318 25.1846 17.6302 24.8646 17.6302 24.4731V24.4681V16.6077V16.6024C17.6302 16.2101 17.318 15.8913 16.9282 15.8913H16.9213H13.3792H13.3709C12.9822 15.8913 12.6696 16.2101 12.6696 16.6024V16.6077V20.179V20.1836C12.6696 20.5766 12.9821 20.8959 13.3709 20.8959H13.3792H16.2129V23.2774H12.1395C11.1274 23.2774 10.3094 22.4515 10.3094 21.4307V15.3566C10.3094 14.3369 11.1275 13.5088 12.1395 13.5088H18.1595C19.1703 13.5088 19.991 14.337 19.991 15.3566V25.7186L19.9911 25.7187ZM18.2251 32.2587H13.3414H13.3342C12.95 32.2587 12.642 32.5714 12.642 32.9594L12.6435 32.9644H12.642V36.4864H12.6435L12.642 36.4883C12.642 36.8744 12.95 37.1918 13.3342 37.1918H13.3414H13.8472H18.2253V39.5416H12.1211V39.5354C11.1231 39.5354 10.3153 38.7207 10.3153 37.7159V31.7271C10.3153 30.7266 11.1231 29.9115 12.1211 29.9115H18.2253V32.2586L18.2251 32.2587Z" fill="#C5D0DB"/>
    </svg>`,
  },
  epic: {
    icon: ``,
  },
  drmfree: {
    icon: ``,
  },
  ps4: {
    icon: ``,
  },
  xbox1: {
    icon: ``,
  },
  nintendo: {
    icon: ``,
  },
  discord: {
    icon: ``,
  },
  oculus: {
    icon: ``,
  },
};

const PAgcGKpricesOld = ({}) => {
  return (
    <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-lg xsui-form-group--primary">
      <div className="xsui-form-group__entry xsui-form-group--primary">
        <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-md">
          {/* <div className="xsui-form-group__label">
          Currency and price
        </div> */}
          <div className="xsui-form-group__entry xsui-form-group--primary">
            {this.state.data.keyData.curs.length > 3 && (
              <FormGroup indentation="sm">
                <div
                  style={{
                    padding: 4,
                    backgroundColor: "#0073f7",
                    borderRadius: 6,
                  }}
                >
                  <Input
                    appearance="flatten"
                    input={{
                      name: "with-icon",
                      onChange: this.setValue,
                    }}
                    offset="left"
                    placeholder="Search platforms and currencies"
                    size="sm"
                    icon="search"
                  />

                  {/* <Input
        input={{ name: 'search', onChange: this.setSearchValue }}
                            icon="search"
placeholder="Filter platforms and currencies"
>
</Input> */}
                </div>
              </FormGroup>
            )}

            <div style={{ position: "relative" }}>
              <div
                className="xsui-form-group__label"
                style={{
                  position: "absolute",
                  right: "1em",
                  fontSize: "80%",
                  zIndex: 100,
                  height: 44,
                  top: 0,
                  display: "flex",
                }}
              >
                DEFAULT&nbsp;&nbsp;
                <Tooltip
                  distance={12}
                  label="This price is used as a default if not set up otherwise. It is automatically converted to a local currency if needed."
                />
              </div>

              <div className="ui-form__prices-selector">
                {this.state.data.keyData.curs.map((oneCur, k) => {
                  return (
                    <PAInputPrices
                      key={k}
                      id={k}
                      curr={oneCur.curr}
                      platform={oneCur.platform}
                      price={oneCur.price}
                      currLocked={oneCur.currLocked}
                      add={oneCur.add}
                      handeCurrDel={this.handeCurrDel.bind(this)}
                      currs={this.state.data.keyData.curs}
                      platforms={this.state.platforms}
                    />
                  );
                })}

                <div style={{ position: "relative" }}>
                  {this.state.data.keyData.curs.length > 1 && (
                    <div
                      className="xsui-form-group__label"
                      style={{
                        position: "absolute",
                        right: 0,
                        bottom: 0,
                      }}
                    >
                      <Button
                        type="button"
                        icon={"upload"}
                        appearance="flatten"
                      >
                        Upload CSV
                      </Button>
                      &nbsp;&nbsp;
                      {/* <Tooltip
                      distance={12}
                      label="Upload .CSV file. The file must contain these fields in the following order: platform, currency, price"
                    /> */}
                      <Dropdown
                        size="sm"
                        autosize={"md"}
                        options={[
                          {
                            label: "Upload .CSV or .TXT file.",
                            description: `The file must contain these fields in the following order: platform, currency, price. Use a line break as the separator.`,
                          },
                          {
                            onClick: () => {
                              void 0;
                            },
                            value: "downloadExample",
                            label: "Download example file",
                            // description: `56 keys will be sent to your email after deletion`,
                            icon: "download",
                          },
                          // {label: 'Update', description: 'Update this item', icon: 'update'}
                        ]}
                      >
                        <Button
                          style={{
                            marginLeft: "4px",
                          }}
                          type="button"
                          size="sm"
                          appearance="flatten"
                        >
                          <div
                            style={{
                              height: 20,
                              width: 20,
                              borderRadius: 100,
                              margin: "0 0px 6px 0",
                              display: "grid",
                              placeContent: "center center",
                              // backgroundColor: "#ccc",
                              border: "1px solid #0073f7",
                            }}
                          >
                            <Icon
                              // onClick={e => {
                              //   this.handlePlatform(onePlatfIndex, "added");
                              // }}
                              name="question"
                            />
                          </div>
                        </Button>
                      </Dropdown>
                    </div>
                  )}

                  <PACollapsePrices
                    sku={this.state.data.sku.value}
                    handleParentCurs={this.handleParentCurs.bind(this)}
                    label=""
                    curs={this.state.data.keyData.curs}
                    platforms={this.state.data.keyData.platforms}
                    handleAddPlatformFromPrices={this.handleAddPlatformFromPrices.bind(
                      this
                    )}
                    // handleCurrValue={this.handleCurrValue.bind(this)}
                  />

                  {this.state.data.keyData.platforms.map((onePlatform, k) => {
                    if (onePlatform["added"])
                      return (
                        <FormGroup border="sm">
                          <GKpriceLines
                            handeCurrDel={this.handeCurrDel}
                            onePlatform={onePlatform}
                          />
                        </FormGroup>
                      );
                  })}

                  {/*
{this.state.data.keyData.curs &&
this.state.data.keyData.curs.map((oneCur, k) => {
return (
<FormGroup
key={k}
// label={`${this.props.label} | ${locale}`}
indentation="sm"
// tooltip={'Project name'}
>

<FormGroup indentation="sm">
<PAInputPrices
key={k}
id={k}
sku={this.props.sku}
curr={oneCur.curr}
platform={oneCur.platform}
price={oneCur.price}
currLocked={oneCur.currLocked}
add={oneCur.add}
handeCurrDel={this.handeCurrDel}
currs={this.state.data.keyData.curs}
platforms={this.state.platforms}
handleAddPlatformFromPrices={this.props.handleAddPlatformFromPrices}
handleCurrValue={this.handleCurrValue}
/>
</FormGroup>

{k + 1 === this.state.data.keyData.curs.length && (
<FormGroup indentation="sm">
<ButtonAction icon="add" onClick={this.handeCurrAdd}>
Add pricing option
</ButtonAction>
</FormGroup>
)}

{/* {(k - 1) === this.state.data.keyData.curs.length && <ButtonAction
icon="add"
onClick={this.handeCurrAdd}>
Add pricing option
</ButtonAction>}
</FormGroup>
);
})} */}
                </div>

                {/* <PAInputPrices curr="USD" platform="All DRMs" price="19.99" currLocked={true} add={true} />

    <PAInputPrices curr="USD" platform="Steam" price="19.99" />

    <PAInputPrices curr="USD" platform="GOG" price="15.99" />

    <PAInputPrices curr="EUR" platform="STEAM" price="15.99"  /> */}

                {/* <ButtonAction
    icon="add"
    onClick={this.handeCurrAdd}>
    Add pricing option
  </ButtonAction> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const PAgameKeysStep1 = () => {
  return (
    <div className="">
      <PAContentBlock title="" border={false}>
        <PAskuName data={blankKey} />

        <PAgcGKbuypre />

        <FormGroup label="Select platforms" indentation="lg">
          <PAgcGKplatforms data={blankKey} />
        </FormGroup>
      </PAContentBlock>
    </div>
  );
};

export const PAgameKeysStep2 = () => {
  return <div className="" />;
};

export const PAgameKeysStep3 = () => {
  return <div className="" />;
};

export const PAgameKeysUpgrades = () => {
  return (
    <FormGroup indentation="lg">
      <div className="xsui-form-group__entry">
        <div>
          <div className="request-upgrades__subheader">Upgrades</div>
          <div className="request-upgrades__description">
            <span>
              Increase average revenue per user (ARPU) by letting gamers upgrade
              to a higher tier package than the one they currently own, while
              only paying the price difference between the two. See{" "}
              <a
                href="https://developers.xsolla.com/recipes/store/upgrades/"
                target="_blank"
              >
                documentation
              </a>
            </span>
          </div>
          <Button size="sm" appearance="outline-secondary">
            Request setup
          </Button>
        </div>
      </div>
    </FormGroup>
  );
};
